export default __webpack_public_path__ + "static/media/facebook.95030d70.svg";